<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.nickname" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="endpoint" label="endpoint" width="160"></el-table-column>
            <el-table-column prop="requestBody" label="requestBody"></el-table-column>
            <el-table-column prop="responseBody" label="responseBody" width="470"></el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="160">
                <template slot-scope="scope">
                    {{ new Date(scope.row.createdAt).toISOString().slice(0, 19).replace('T', ' ') }}
                </template>
            </el-table-column>
            <el-table-column prop="durationMs" label="调用时长" width="110">
                <template slot-scope="scope">
                    {{ scope.row.durationMs }}ms
                </template>
            </el-table-column>
            <el-table-column prop="responseCode" label="响应码" width="80"></el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            
        }
    },
    methods: {
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "API_LOGS";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>